import { useMemo } from 'react'
import DPFFeatureImg1 from '../assets/landing/DPF-feature-img-1.png'
import DPFFeatureImg2 from '../assets/landing/DPF-feature-img-2.png'
import DPFFeatureImg3 from '../assets/landing/DPF-feature-img-3.png'

export default function HeroSection() {
  const FEATURES = useMemo(
    () => [
      {
        imgSrc: DPFFeatureImg1,
        title: (
          <>
            スライドショーで
            <br />
            みてねにある思い出を振り返れる
          </>
        ),
        pillText: 'Point 1',
        description: (
          <>
            みてねにあるたくさんの思い出が、一度設定するだけで自動でフレームに届きます。
            <br />
            みてねアプリからいつでも簡単に表示内容を変更できるので、小さなお子さまから祖父母世代まで、気軽にお楽しみいただけます。
          </>
        ),
      },
      {
        imgSrc: DPFFeatureImg2,
        title: (
          <>
            複数アルバムの写真や動画も、
            <br />
            1台でまとめて再生
          </>
        ),
        pillText: 'Point 2',
        description: (
          <>
            複数のアルバムに参加している場合は表示したいアルバムを選ぶことで、切り替えの手間なくまとめてスライドショー表示できます。
            <br />
            ※プレミアム契約中のアルバムのみ、すべての写真・動画が表示できます。
          </>
        ),
      },
      {
        imgSrc: DPFFeatureImg3,
        title: <>スマホからも操作できる！</>,
        pillText: 'Point 3',
        description: (
          <>スライドショーの内容変更やスリープの設定などは、みてねアプリから操作できます。</>
        ),
      },
    ],
    [],
  )

  return (
    <section className='px-4 pt-4 pb-8'>
      <div className='text-center mb-8'>
        <h1 className='text-2xl font-semibold text-gray-12'>
          みてねの思い出を
          <br />
          もっと家族のそばに
        </h1>
      </div>

      <div className='flex flex-col justify-center items-center space-y-10'>
        {FEATURES.map(feature => (
          <div key={feature.pillText} className='w-full max-w-md'>
            <img
              src={feature.imgSrc}
              alt={feature.pillText}
              className='w-full rounded-lg mb-6'
              loading='lazy'
            />
            <div className='mx-auto block w-fit mb-2'>
              <span className='text-sm font-bold uppercase bg-[#F29CB2] text-white px-2 py-1 rounded-full'>
                {feature.pillText}
              </span>
            </div>
            <div className='text-center space-y-4'>
              <h2 className='text-xl font-bold text-gray-12'>{feature.title}</h2>
              <p className='text-base font-normal text-left text-gray-12 leading-[160%] tracking-0'>
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
